module.exports = __webpack_public_path__ + "img/example2-3.0ba32ff5.png";